import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'src/app-redux/rtkq.interceptor';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import { apiResources } from 'src/common/Constants';
import { Fleet, ICreateFleetArgs } from 'src/management/Fleet';

const fleetsTag = 'fleets';

/** RTK Query API slice for fleet management endpoints. */
export const fleetsApi = createApi({
  reducerPath: 'fleetsApi',
  tagTypes: [fleetsTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch all fleets. */
    fetchFleets: builder.query<Fleet[], void>({
      providesTags: [fleetsTag],
      query: () => apiResources.fleet,
      ...transformResponses,
    }),
    /** Mutation to create a new fleet. */
    createFleet: builder.mutation<Fleet, ICreateFleetArgs>({
      query: (fleet) => ({
        url: apiResources.fleet,
        method: 'POST',
        body: fleet,
      }),
      invalidatesTags: (_result, error) => (error ? [] : [fleetsTag]),
    }),
  }),
});

/** RTK Query hooks for fleet management endpoints. */
export const { useCreateFleetMutation, useFetchFleetsQuery } = fleetsApi;
